module.exports = __webpack_public_path__ + "static/dsp_seal-c72d4f37cdcfad130f50dca1ebdd90cd.png";